import { mergeStyles } from '@cian/utils';
import React, { FC, ReactNode } from 'react';
import styles from './Link.css';

interface IProps {
  className?: string;
  target?: string;
  title?: string;
  href?: string;
  rel?: string;
  role?: string;
  children?: ReactNode;
  // oxlint-disable-next-line typescript/no-explicit-any
  onClick?(e?: any): void;
}

export const Link: FC<IProps> = ({ title, target, href, rel, role, className, onClick, children }) => {
  const linkStyles = mergeStyles([styles['link-default'], className]);

  return (
    <a
      title={title}
      target={target}
      href={href}
      role={role}
      className={linkStyles.className}
      style={linkStyles.style}
      rel={rel || (target === '_blank' ? 'noreferrer' : undefined)}
      onClick={e => onClick?.(e)}
    >
      {children}
    </a>
  );
};
